import { Routes, Route, Navigate } from 'react-router-dom';
import { SaaSLayout } from './components/layouts/SaaSLayout';
import { CasinoLayout } from './components/layouts/CasinoLayout';
import { PlayerLayout } from './components/layouts/PlayerLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { LoginPage } from './components/auth/LoginPage';
import { UnauthorizedPage } from './components/auth/UnauthorizedPage';
import { SaaSDashboard } from './views/saas/Dashboard';
import { CasinoDashboard } from './views/casino/Dashboard';
import { PlayerDashboard } from './views/player/Dashboard';
import { StyleGuide } from './views/design-system/StyleGuide';
import { UserRole } from '../../shared/backend/types';

function App(): React.ReactElement {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/saas/dashboard" replace />} />

      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route
        path="/saas"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SAAS_OWNER]}>
            <SaaSLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/saas/dashboard" replace />} />
        <Route path="dashboard" element={<SaaSDashboard />} />
        <Route path="style-guide" element={<StyleGuide />} />
      </Route>

      <Route
        path="/casino"
        element={
          <ProtectedRoute allowedRoles={[UserRole.CASINO_MANAGER, UserRole.MANAGER, UserRole.AGENT]}>
            <CasinoLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/casino/dashboard" replace />} />
        <Route path="dashboard" element={<CasinoDashboard />} />
      </Route>

      <Route
        path="/player"
        element={
          <ProtectedRoute allowedRoles={[UserRole.PLAYER]}>
            <PlayerLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/player/dashboard" replace />} />
        <Route path="dashboard" element={<PlayerDashboard />} />
      </Route>

      <Route path="*" element={<Navigate to="/saas/dashboard" replace />} />
    </Routes>
  );
}

export default App;
